import React from "react"
import { url } from "./constant"

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="w-full px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-3">
            <div className="text-2xl font-semibold" style={{color: '#62329f'}}>TrackFam</div>
            <p className="text-gray-300">Your Family. Your Safety.</p>
            <p className="text-gray-300">Your Peace of Mind</p>
          </div>

          {/* <div>
            <h3 className="font-semibold mb-4" style={{color: '#62329f'}}>Quick Links</h3>
            <ul className="space-y-3">
              
              <li><a href="/pricing" className="text-gray-300 hover:text-white">Pricing</a></li>
              <li><a href="/about" className="text-gray-300 hover:text-white">About Us</a></li>
            </ul>
          </div> */}

          <div>
            <h3 className="font-semibold mb-4" style={{color: '#62329f'}}>Support</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-white">Help Center</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white">Contact Us</a></li>
              <li><a href="/privacy-policy" className="text-gray-300 hover:text-white">Privacy Policy</a></li>
              <li><a href="/terms-of-service" className="text-gray-300 hover:text-white">Terms of Service</a></li>
            </ul>
          </div>

          <div className="flex flex-col items-center">
            <h3 className="font-semibold mb-4" style={{color: '#62329f'}}>Follow Us</h3>
            <div className="flex items-center gap-4">
              <a href={url} className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center hover:bg-white/20 transition-colors">
                <img src="/twitter-logo.svg" alt="X" className="w-4 h-4 brightness-0 invert block object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                <span className="hidden text-white text-sm font-semibold">X</span>
              </a>
              <a href={url} className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center hover:bg-white/20 transition-colors">
                <img src="/facebook-logo.svg" alt="Facebook" className="w-4 h-4 brightness-0 invert block object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                <span className="hidden text-white text-sm font-semibold">f</span>
              </a>
              <a href={url} className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center hover:bg-white/20 transition-colors">
                <img src="/instagram-logo.svg" alt="Instagram" className="w-4 h-4 brightness-0 invert block object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                <span className="hidden text-white text-sm font-semibold">IG</span>
              </a>
              <a href={url} className="w-9 h-9 bg-white/10 rounded-md flex items-center justify-center hover:bg-white/20 transition-colors">
                <img src="/linkedin-logo.svg" alt="LinkedIn" className="w-4 h-4 brightness-0 invert block object-contain" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                <span className="hidden text-white text-sm font-semibold">in</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6">
          <p className="text-center text-gray-300 text-sm">© 2025 TrackFam by Washey Information Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
